// extracted by mini-css-extract-plugin
export default {"contact_head":"QueryForm_contact_head__id0mb","bottom":"QueryForm_bottom__7fiW4","label_ts":"QueryForm_label_ts__zBK49","submit_btn":"QueryForm_submit_btn__NxJQD"};